export const numberWithCommas = (x: number) => {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

/**
 * 強制轉換為正整數
 */
export const enforcePositiveInteger = (value: string | number) => {
  const pureValue = value.toString().replace(/[^0-9]/g, '');
  const positiveValue = pureValue.replace(/^0+/, '');
  const positiveInteger = Number(positiveValue);
  return positiveInteger;
};
